export default __webpack_public_path__ + "static/media/page8.256fe9d8.webp";